// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  margin-bottom: 6px;
  justify-content: center;
  gap: 5px;
}
.header-icon {
  width: 30px;
  height: 30px;
  border-radius: 50%;
}
.header-title {
  font-size: 24px;
  line-height: 32px;
  font-weight: 600;
}
.cashier {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.cashier-wallet {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: transparent;
  transition: all 0.25s;
  cursor: pointer;
  border-radius: 4px;
  text-align: center;
  min-width: 90px;
}
.cashier-wallet > span {
  width: 100%;
  margin-top: 6px;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
}
.cashier-wallet-icon {
  display: flex;
  width: 52px;
  height: 52px;
  border-radius: 16px;
}
.cashier-body {
  flex: 1;
}
.cashier-body-gridLayout {
  display: grid !important;
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.cashier-body-wallets {
  display: flex;
  gap: 22px;
  justify-content: center;
  flex-wrap: wrap;
  padding-inline: 20px;
  min-height: 88px;
  max-height: 202px;
  overflow: auto;
}
.cashier-body-wallets > div {
  flex-shrink: 0;
}
.cashier-body-tips {
  margin: 24px 68px 0;
  font-size: 14px;
  line-height: 16.8px;
  text-align: center;
  color: var(--text);
}
.cashier-body-prices {
  font-size: 60px;
  font-weight: 800;
  line-height: 80px;
  text-align: center;
}
.cashier-body-prices span {
  font-size: 28px;
  font-weight: 600;
}
.cashier-body-network {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  line-height: 22x;
  color: #000000E5;
  margin-top: -1px;
}
.cashier-body-contract {
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  color: #474646e5;
}
.cashier-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  font-size: 14px;
  border-top: 1px solid #B4B4B440;
  color: var(--text);
}
.cashier-footer > div {
  color: var(--primary);
  margin-left: 2px;
}
.cashier-title {
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  margin: 30px 0 24px;
  color: var(--text);
}
.cashier-tabs {
  width: 296px;
  margin: 0 auto;
}
.cashier-tabs-content {
  display: flex;
}
.cashier-tabs-content > div {
  flex: 1;
  text-align: center;
  padding: 9px 0;
  color: #8E918F;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.25s;
}
.cashier-tabs-content > div:hover {
  color: var(--primary-hover);
}
.cashier-tabs-content > div.actived {
  color: var(--primary);
}
.cashier-tabs-line {
  position: relative;
  width: 100%;
  height: 3px;
  background-color: #d9d9d9;
  border-radius: 1px;
}
.cashier-tabs-line > div {
  position: absolute;
  height: 3px;
  transition: left 0.25s;
  background-color: var(--primary);
  border-radius: 1px;
}
.cashier .powerBy {
  margin-top: 20px;
  font-family: Darker Grotesque;
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
  text-align: center;
  color: #00000080;
}
.cashier .powerBy a {
  color: #25B2D4;
}
.paymentWrapper {
  border-radius: 20px;
  border: 1px solid #E8E8E8;
  margin-top: 46px;
}
.payment {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  border-bottom: 1px solid #E8E8E8;
}
.payment-info {
  flex: 1;
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  color: #00000080;
  overflow: hidden;
}
.payment-info-address {
  font-weight: 600;
  font-size: 20px;
  line-height: 26px;
  color: #218741;
  white-space: nowrap;
  margin-bottom: 4px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}
.payment-info-address .ant-typography-copy {
  height: 24px;
  margin-inline-start: unset;
  color: #000000;
}
.payment-info-address .ant-typography-copy svg {
  width: 24px;
  height: 24px;
}
.payment-info-address .ant-typography-copy span svg {
  color: #218741;
  margin-block: 2px;
  margin-left: 4px;
  width: 20px;
  height: 20px;
}
.payment-info-address .ant-typography-copy-success {
  color: #000000 !important;
}
.payment-info-email,
.payment-info-email:active {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  color: #25B2D4;
  cursor: pointer;
}
.payment-info-email svg,
.payment-info-email:active svg {
  margin-top: 2px;
}
.payment-info-email:hover {
  color: #2AD0F8;
}
.payment-content {
  padding-top: 14px;
  padding-left: 24px;
}
.payment-qrCode {
  position: relative;
}
.payment-qrCode-mask {
  position: absolute;
  top: -2px;
  left: -2px;
  height: calc(100% + 4px);
  width: calc(100% + 4px);
  border-radius: 6px;
  background-color: #0000001A;
  backdrop-filter: blur(2px);
}
.payment-qrCode-mask img {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 36px;
  height: 36px;
  transform: translate(-50%, -50%);
}
.payment canvas {
  flex-shrink: 0;
  border-radius: 6px;
}
.status {
  display: flex;
  align-items: center;
}
.status-card {
  flex: 1;
  flex-shrink: 0;
  height: 68px;
  padding: 14px;
  display: flex;
  align-items: center;
  gap: 24px;
}
.status-card img {
  margin-left: 10px;
}
.status-card-content {
  flex: 1;
}
.status-card:first-child {
  border-right: 1px solid #E8E8E8;
}
.trading {
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
}
.trading-status {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
}
.trading-status-item {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #EEEEEE;
}
.trading-status-item-active {
  background-color: #181818;
}
.divider {
  margin: 20px 0 44px 0 !important;
  padding-inline: 48px;
  border-color: #E8E8E8;
}
.divider .ant-divider-inner-text {
  padding: 0 8px;
  color: #00000080;
  font-weight: 600;
  line-height: 20px;
}
.trading-animation {
  animation: rotating 2s linear infinite;
}
@keyframes rotating {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@media screen and (max-width: 452px) {
  .header {
    margin-bottom: 15px;
    justify-content: center;
    gap: 5px;
  }
  .header-icon {
    width: 28px;
    height: 28px;
  }
  .header-title {
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
  }
  .cashier-body-prices {
    font-size: 46px;
    font-weight: 800;
    line-height: 64px;
  }
  .cashier-body-prices > span {
    font-size: 22px;
    line-height: 30px;
    font-weight: 600;
  }
  .paymentWrapper {
    margin-top: 35px;
  }
  .payment {
    display: block;
    padding: 18px 0 12px;
  }
  .payment-qrCode {
    text-align: center;
  }
  .payment-info {
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    text-align: center;
  }
  .payment-info-address {
    margin-top: 12px;
    text-align: center;
    margin-bottom: 14px !important;
    font-size: 16px;
    line-height: 22px;
  }
  .payment-info-address-value {
    max-width: calc(100% - 24px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .payment-info-address .ant-typography-copy {
    height: 20px;
    margin-inline-start: unset;
    color: #000000;
  }
  .payment-info-address .ant-typography-copy svg {
    width: 20px;
    height: 20px;
  }
  .payment-info-address .ant-typography-copy span svg {
    margin-top: 2px;
    margin-left: 2px;
    width: 18px;
    height: 16px;
  }
  .payment-info .address-title {
    display: none;
  }
  .payment-info .payment-info-address {
    padding-right: unset;
    font-size: 14px;
  }
  .payment-content {
    padding-top: unset;
    padding-left: unset;
  }
  .payment-content .payment-info-address {
    padding-right: unset;
    margin-top: unset;
  }
  .status-card {
    height: 58px;
    padding: 12px;
    gap: 14px;
  }
  .status-card img {
    margin-left: 2px;
    width: 32px;
    height: 32px;
  }
  .divider {
    margin: 16px 0 26px 0 !important;
  }
  .divider .ant-divider-inner-text {
    padding: 0 6px;
    font-weight: 500;
  }
  .cashier-body-wallets {
    min-height: 182px;
    max-height: unset;
    height: calc(100vh - 550px);
  }
  .cashier-body-gridLayout {
    grid-auto-rows: 80px;
  }
  .cashier-wallet > span {
    font-size: 14px;
    font-weight: 500;
  }
  .cashier-wallet-icon {
    width: 48px;
    height: 48px;
    border-radius: 14px;
  }
  .cashier-wallet {
    min-width: 60px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/cashier/style.less"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,uBAAA;EACA,QAAA;AACJ;AACI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AACR;AAEI;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;AAAR;AAIA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AAFJ;AAII;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,6BAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AAFR;AAPI;EAYQ,WAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAFZ;AAKQ;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAHZ;AAOI;EACI,OAAA;AALR;AAOQ;EACI,wBAAA;EACA,gDAAA;AALZ;AAQQ;EACI,aAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AANZ;AAFQ;EAWQ,cAAA;AANhB;AAUQ;EACI,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AARZ;AAWQ;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AATZ;AAKQ;EAOQ,eAAA;EACA,gBAAA;AAThB;AAaQ;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AAXZ;AAcQ;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAZZ;AAgBI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,+BAAA;EACA,kBAAA;AAdR;AAOI;EAUQ,qBAAA;EACA,gBAAA;AAdZ;AAkBI;EACI,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AAhBR;AAmBI;EACI,YAAA;EACA,cAAA;AAjBR;AAmBQ;EACI,aAAA;AAjBZ;AAgBQ;EAIQ,OAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,qBAAA;AAjBhB;AAmBgB;EACI,2BAAA;AAjBpB;AAoBgB;EACI,qBAAA;AAlBpB;AAuBQ;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;AArBZ;AAgBQ;EAQQ,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,gCAAA;EACA,kBAAA;AArBhB;AArIA;EAgKQ,gBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AAxBR;AA9IA;EAyKY,cAAA;AAxBZ;AA6BA;EACI,mBAAA;EACA,yBAAA;EACA,gBAAA;AA3BJ;AA8BA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,gCAAA;AA5BJ;AA8BI;EACI,OAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AA5BR;AA8BQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AA5BZ;AAkBQ;EAaQ,YAAA;EACA,0BAAA;EACA,cAAA;AA5BhB;AAaQ;EAkBY,WAAA;EACA,YAAA;AA5BpB;AASQ;EAwBgB,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;AA9BxB;AAEQ;EAkCQ,yBAAA;AAjChB;AAqCQ;;EAEI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AAnCZ;AA0BQ;;EAYQ,eAAA;AAlChB;AAsCQ;EACI,cAAA;AApCZ;AAwCI;EACI,iBAAA;EACA,kBAAA;AAtCR;AAyCI;EACI,kBAAA;AAvCR;AAyCQ;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,wBAAA;EACA,uBAAA;EACA,kBAAA;EACA,2BAAA;EACA,0BAAA;AAvCZ;AA+BQ;EAWQ,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,gCAAA;AAvChB;AA3DA;EAwGQ,cAAA;EACA,kBAAA;AA1CR;AA8CA;EACI,aAAA;EACA,mBAAA;AA5CJ;AA8CI;EACI,OAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AA5CR;AAqCI;EAUQ,iBAAA;AA5CZ;AA+CQ;EACI,OAAA;AA7CZ;AAiDI;EACI,+BAAA;AA/CR;AAmDA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;AAjDJ;AAmDI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AAjDR;AAmDQ;EACI,UAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;AAjDZ;AAmDY;EACI,yBAAA;AAjDhB;AAuDA;EACI,gCAAA;EACA,oBAAA;EACA,qBAAA;AArDJ;AAkDA;EAMQ,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AArDR;AAyDA;EACI,sCAAA;AAvDJ;AA0DA;EACI;IACI,oBAAA;EAxDN;EA2DE;IACI,yBAAA;EAzDN;AACF;AA4DA;EACI;IACI,mBAAA;IACA,uBAAA;IACA,QAAA;EA1DN;EA4DM;IACI,WAAA;IACA,YAAA;EA1DV;EA6DM;IACI,eAAA;IACA,gBAAA;IACA,iBAAA;EA3DV;EA+DE;IACI,eAAA;IACA,gBAAA;IACA,iBAAA;EA7DN;EA0DE;IAMQ,eAAA;IACA,iBAAA;IACA,gBAAA;EA7DV;EAiEE;IACI,gBAAA;EA/DN;EAkEE;IACI,cAAA;IACA,oBAAA;EAhEN;EAkEM;IACI,kBAAA;EAhEV;EAoEE;IACI,eAAA;IACA,gBAAA;IACA,iBAAA;IACA,kBAAA;EAlEN;EAqEM;IACI,gBAAA;IACA,kBAAA;IACA,8BAAA;IACA,eAAA;IACA,iBAAA;EAnEV;EAqEU;IACI,4BAAA;IACA,mBAAA;IACA,gBAAA;IACA,uBAAA;EAnEd;EAwDM;IAeQ,YAAA;IACA,0BAAA;IACA,cAAA;EApEd;EAmDM;IAoBY,WAAA;IACA,YAAA;EApElB;EA+CM;IA0BgB,eAAA;IACA,gBAAA;IACA,WAAA;IACA,YAAA;EAtEtB;EAkCE;IA2CQ,aAAA;EA1EV;EA+BE;IA+CQ,oBAAA;IACA,eAAA;EA3EV;EA+EE;IACI,kBAAA;IACA,mBAAA;EA7EN;EA2EE;IAKQ,oBAAA;IACA,iBAAA;EA7EV;EAkFM;IACI,YAAA;IACA,aAAA;IACA,SAAA;EAhFV;EA6EM;IAMQ,gBAAA;IACA,WAAA;IACA,YAAA;EAhFd;EAqFE;IACI,gCAAA;EAnFN;EAkFE;IAIQ,cAAA;IACA,gBAAA;EAnFV;EAuFE;IACI,iBAAA;IACA,iBAAA;IACA,2BAAA;EArFN;EAwFE;IACI,oBAAA;EAtFN;EAyFE;IAEQ,eAAA;IACA,gBAAA;EAxFV;EA2FM;IACI,WAAA;IACA,YAAA;IACA,mBAAA;EAzFV;EA6FE;IACI,eAAA;EA3FN;AACF","sourcesContent":[".header {\n    margin-bottom: 6px;\n    justify-content: center;\n    gap: 5px;\n\n    &-icon {\n        width: 30px;\n        height: 30px;\n        border-radius: 50%;\n    }\n\n    &-title {\n        font-size: 24px;\n        line-height: 32px;\n        font-weight: 600;\n    }\n}\n\n.cashier {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n\n    &-wallet {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        background-color: transparent;\n        transition: all .25s;\n        cursor: pointer;\n        border-radius: 4px;\n        text-align: center;\n        min-width: 90px;\n\n        > span {\n            width: 100%;\n            margin-top: 6px;\n            font-size: 16px;\n            font-weight: 600;\n            text-align: center;\n        }\n\n        &-icon {\n            display: flex;\n            width: 52px;\n            height: 52px;\n            border-radius: 16px;\n        }\n    }\n\n    &-body {\n        flex: 1;\n\n        &-gridLayout {\n            display: grid !important;\n            grid-template-columns: repeat(4, minmax(0, 1fr));\n        }\n\n        &-wallets {\n            display: flex;\n            gap: 22px;\n            justify-content: center;\n            flex-wrap: wrap;\n            padding-inline: 20px;\n            min-height: 88px;\n            max-height: 202px;\n            overflow: auto;\n\n            > div {\n                flex-shrink: 0;\n            }\n        }\n\n        &-tips {\n            margin: 24px 68px 0;\n            font-size: 14px;\n            line-height: 16.8px;\n            text-align: center;\n            color: var(--text);\n        }\n\n        &-prices {\n            font-size: 60px;\n            font-weight: 800;\n            line-height: 80px;\n            text-align: center;\n\n            span {\n                font-size: 28px;\n                font-weight: 600;\n            }\n        }\n\n        &-network {\n            text-align: center;\n            font-size: 16px;\n            font-weight: 600;\n            line-height: 22x;\n            color: #000000E5;\n            margin-top: -1px;\n        }\n\n        &-contract {\n            text-align: center;\n            font-size: 14px;\n            font-weight: 600;\n            line-height: 22px;\n            color: #474646e5;\n        }\n    }\n\n    &-footer {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        height: 50px;\n        font-size: 14px;\n        border-top: 1px solid #B4B4B440;\n        color: var(--text);\n\n        >div {\n            color: var(--primary);\n            margin-left: 2px\n        }\n    }\n\n    &-title {\n        font-size: 20px;\n        line-height: 24px;\n        text-align: center;\n        margin: 30px 0 24px;\n        color: var(--text);\n    }\n\n    &-tabs {\n        width: 296px;\n        margin: 0 auto;\n\n        &-content {\n            display: flex;\n\n            >div {\n                flex: 1;\n                text-align: center;\n                padding: 9px 0;\n                color: #8E918F;\n                font-size: 14px;\n                cursor: pointer;\n                transition: all .25s;\n\n                &:hover {\n                    color: var(--primary-hover)\n                }\n\n                &.actived {\n                    color: var(--primary)\n                }\n            }\n        }\n\n        &-line {\n            position: relative;\n            width: 100%;\n            height: 3px;\n            background-color: #d9d9d9;\n            border-radius: 1px;\n\n            >div {\n                position: absolute;\n                height: 3px;\n                transition: left .25s;\n                background-color: var(--primary);\n                border-radius: 1px;\n            }\n        }\n    }\n    \n    .powerBy {\n        margin-top: 20px;\n        font-family: Darker Grotesque;\n        font-size: 18px;\n        font-weight: 400;\n        line-height: 24px;\n        text-align: center;\n        color: #00000080;\n\n        a {\n            color: #25B2D4;\n        }\n    }\n}\n\n.paymentWrapper {\n    border-radius: 20px;\n    border: 1px solid #E8E8E8;\n    margin-top: 46px;\n}\n\n.payment {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 10px;\n    border-bottom: 1px solid #E8E8E8;\n\n    &-info {\n        flex: 1;\n        font-size: 18px;\n        font-weight: 500;\n        line-height: 24px;\n        color: #00000080;\n        overflow: hidden;\n\n        &-address {\n            font-weight: 600;\n            font-size: 20px;\n            line-height: 26px;\n            color: #218741;\n            white-space: nowrap;\n            margin-bottom: 4px !important;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            gap: 4px;\n\n            .ant-typography-copy {\n                height: 24px;\n                margin-inline-start: unset;\n                color: #000000;\n\n                svg {\n                    width: 24px;\n                    height: 24px;\n                }\n\n                span {\n                    svg {\n                        color: #218741;\n                        margin-block: 2px;\n                        margin-left: 4px;\n                        width: 20px;\n                        height: 20px;\n                    }\n                }\n            }\n\n            .ant-typography-copy-success {\n                color: #000000 !important;\n            }\n        }\n\n        &-email,\n        &-email:active {\n            display: inline-flex;\n            align-items: center;\n            gap: 8px;\n            font-size: 14px;\n            font-weight: 600;\n            line-height: 18px;\n            color: #25B2D4;\n            cursor: pointer;\n\n            svg {\n                margin-top: 2px;\n            }\n        }\n\n        &-email:hover {\n            color: #2AD0F8;\n        }\n    }\n\n    &-content {\n        padding-top: 14px;\n        padding-left: 24px;\n    }\n\n    &-qrCode {\n        position: relative;\n\n        &-mask {\n            position: absolute;\n            top: -2px;\n            left: -2px;\n            height: calc(100% + 4px);\n            width: calc(100% + 4px);\n            border-radius: 6px;\n            background-color: #0000001A;\n            backdrop-filter: blur(2px);\n\n            img {\n                position: absolute;\n                top: 50%;\n                left: 50%;\n                width: 36px;\n                height: 36px;\n                transform: translate(-50%, -50%);\n            }\n        }\n    }\n    \n    canvas {\n        flex-shrink: 0;\n        border-radius: 6px;\n    }\n}\n\n.status {\n    display: flex;\n    align-items: center;\n\n    &-card {\n        flex: 1;\n        flex-shrink: 0;\n        height: 68px;\n        padding: 14px;\n        display: flex;\n        align-items: center;\n        gap: 24px;\n\n        img {\n            margin-left: 10px;\n        }\n\n        &-content {\n            flex: 1;\n        }\n    }\n\n    &-card:first-child {\n        border-right: 1px solid #E8E8E8;\n    }\n}\n\n.trading {\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 24px;\n\n    &-status {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        gap: 4px;\n\n        &-item {\n            width: 6px;\n            height: 6px;\n            border-radius: 50%;\n            background-color: #EEEEEE;\n\n            &-active {\n                background-color: #181818;\n            }\n        }\n    }\n}\n\n.divider {\n    margin: 20px 0 44px 0 !important;\n    padding-inline: 48px;\n    border-color: #E8E8E8;\n\n    .ant-divider-inner-text {\n        padding: 0 8px;\n        color: #00000080;\n        font-weight: 600;\n        line-height: 20px;\n    }\n}\n\n.trading-animation {\n    animation: rotating 2s linear infinite;\n}\n\n@keyframes rotating {\n    from {\n        transform: rotate(0);\n    }\n\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n@media screen and (max-width: 452px) {\n    .header {\n        margin-bottom: 15px;\n        justify-content: center;\n        gap: 5px;\n    \n        &-icon {\n            width: 28px;\n            height: 28px;\n        }\n    \n        &-title {\n            font-size: 20px;\n            font-weight: 600;\n            line-height: 28px;\n        }\n    }\n\n    .cashier-body-prices {\n        font-size: 46px;\n        font-weight: 800;\n        line-height: 64px;\n\n        > span {\n            font-size: 22px;\n            line-height: 30px;\n            font-weight: 600;\n        }\n    }\n\n    .paymentWrapper {\n        margin-top: 35px;\n    }\n    \n    .payment {\n        display: block;\n        padding: 18px 0 12px;\n\n        &-qrCode {\n            text-align: center;\n        }\n    }\n\n    .payment-info {\n        font-size: 16px;\n        font-weight: 400;\n        line-height: 22px;\n        text-align: center;\n\n\n        &-address {\n            margin-top: 12px;\n            text-align: center;\n            margin-bottom: 14px !important;\n            font-size: 16px;\n            line-height: 22px;\n\n            &-value {\n                max-width: calc(100% - 24px);\n                white-space: nowrap;\n                overflow: hidden;\n                text-overflow: ellipsis;\n            }\n\n            .ant-typography-copy {\n                height: 20px;\n                margin-inline-start: unset;\n                color: #000000;\n\n                svg {\n                    width: 20px;\n                    height: 20px;\n                }\n\n                span {\n                    svg {\n                        margin-top: 2px;\n                        margin-left: 2px;\n                        width: 18px;\n                        height: 16px;\n                    }\n                }\n            }\n        }\n\n        .address-title {\n            display: none;\n        }\n\n        .payment-info-address {\n            padding-right: unset;\n            font-size: 14px;\n        }\n    }\n    \n    .payment-content {\n        padding-top: unset;\n        padding-left: unset;\n\n        .payment-info-address {\n            padding-right: unset;\n            margin-top: unset;\n        }\n    }\n\n    .status {\n        &-card {\n            height: 58px;\n            padding: 12px;\n            gap: 14px;\n    \n            img {\n                margin-left: 2px;\n                width: 32px;\n                height: 32px;\n            }\n        }\n    }\n\n    .divider {\n        margin: 16px 0 26px 0 !important;\n        \n        .ant-divider-inner-text {\n            padding: 0 6px;\n            font-weight: 500;\n        }\n    }\n\n    .cashier-body-wallets{\n        min-height: 182px;\n        max-height: unset;\n        height: calc(100vh - 550px);\n    }\n\n    .cashier-body-gridLayout {\n        grid-auto-rows: 80px;\n    }\n\n    .cashier-wallet {\n        > span {\n            font-size: 14px;\n            font-weight: 500;\n        }\n\n        &-icon {\n            width: 48px;\n            height: 48px;\n            border-radius: 14px;\n        }\n    }\n\n    .cashier-wallet {\n        min-width: 60px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
